import {deleteEvent} from '@/rest/events/delete-event';
import {joinEvent} from '@/rest/events/join-event';
import {leaveEvent} from '@/rest/events/leave-event';
import {removeEventFromEvents} from '@/redux-store/slices/events';
import {EventData} from '@/types/event';
import {AnyAction} from '@reduxjs/toolkit';
import {cancelEvent} from '@/rest/events/cancel-event';

export async function joinEventFunc(
  selectedEvent: EventData | null,
  showSnackbarMessage: (message: string, variant: 'success' | 'error') => void,
  t: (key: string) => string,
  setEvent: (event: EventData) => void,
  onChange?: (event: EventData) => void
) {
  if (selectedEvent) {
    const eventId = selectedEvent._id;
    joinEvent(eventId)
      .then((response) => {
        if (response) {
          showSnackbarMessage(t('event_joining_success'), 'success');
          setEvent(response);
          if (onChange) onChange(response);
        } else {
          showSnackbarMessage(t('event_joining_failure'), 'error');
        }
      })
      .catch((error) => {
        console.error('Error joining event:', error);
        showSnackbarMessage(t('event_joining_failure'), 'error');
      });
  }
}

export function leaveEventFunc(
  selectedEvent: EventData | null,
  showSnackbarMessage: (message: string, variant: 'success' | 'error') => void,
  t: (key: string) => string,
  setEvent: (event: EventData) => void,
  onChange?: (event: EventData) => void
) {
  if (selectedEvent) {
    const eventId = selectedEvent._id;

    leaveEvent(eventId)
      .then((response) => {
        if (response) {
          showSnackbarMessage(t('event_leaving_success'), 'success');
          setEvent(response);
          if (onChange) onChange(response);
        } else {
          showSnackbarMessage(t('event_leaving_failure'), 'error');
        }
      })
      .catch((error) => {
        console.error('Error leaving event:', error);
        showSnackbarMessage(t('event_leaving_failure'), 'error');
      });
  }
}

export function deleteEventFunc(
  selectedEvent: EventData | null,
  onClose: () => void,
  showSnackbarMessage: (message: string, variant: 'success' | 'error') => void,
  t: (key: string) => string,
  dispatch: React.Dispatch<AnyAction>,
  handleCloseSelectedEvent: () => void,
  refreshCompanyData: () => void,
  onDelete?: (eventId: string) => void
) {
  if (selectedEvent) {
    const eventId = selectedEvent._id;

    deleteEvent(eventId)
      .then((response) => {
        if (response) {
          showSnackbarMessage(t('event_deleting_success'), 'success');
          onClose();
          if (onDelete) {
            onDelete(eventId);
          }
          dispatch(removeEventFromEvents(eventId));
          refreshCompanyData();
          handleCloseSelectedEvent();
        } else {
          showSnackbarMessage(t('event_deleting_failure'), 'error');
        }
      })
      .catch((error) => {
        console.error('Error deleting event:', error);
        showSnackbarMessage(t('event_deleting_failure'), 'error');
      });
  }
}

export async function cancelEventFunc(
  selectedEvent: EventData | null,
  onClose: () => void,
  showSnackbarMessage: (message: string, variant: 'success' | 'error') => void,
  t: (key: string) => string,
  onChange?: (event: EventData) => void
): Promise<EventData | null> {
  if (selectedEvent) {
    const eventId = selectedEvent._id;

    try {
      const response = await cancelEvent(eventId);

      if (response) {
        showSnackbarMessage(t('event_cancelling_success'), 'success');
        onClose();
        if (onChange) {
          onChange(response);
        }
        return response;
      } else {
        showSnackbarMessage(t('event_cancelling_failure'), 'error');
        return null;
      }
    } catch (error) {
      console.error('Error cancelling event:', error);
      showSnackbarMessage(t('event_cancelling_failure'), 'error');
      return null;
    }
  }
  return null;
}
